import React, { useEffect, useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import t, { partial } from '../../util/translation/translation';
import renderSelectField from '../../shared/components/form/Select';
import validateWebsiteComponentForm from './validateWebsiteComponentForm';
import renderField from '../../shared/components/custom/Field';

const WebsiteComponentForm = ({
  component,
  handleSubmit,
  initialize,
  onClose,
  itemName,
  change,
  availableEntities,
  renderDetails,
}) => {
  const s = partial('shared');
  // The chosen entity's id, for the details shown under the select
  const [selectedValue, setSelectedValue] = useState(component?.value || null);

  const entities = availableEntities[component.id.split('specific-')[1]];

  useEffect(() => {
    const init = async () => {
      setSelectedValue(component?.value || null);
      if (component?.value) {
        initialize({
          selectedEntity: entities.find(
            (item) => item.value === component.value
          ),
          label: component.label,
        });
      } else {
        initialize({
          selectedEntity: null,
          label: '',
        });
      }
    };
    init();
  }, [component]);

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="qm-body">
        <div className="form__form-group mb-0">
          <span className="form-header">{itemName}</span>
          <Field
            name="selectedEntity"
            placeholder={`${s('select')} ${itemName}`}
            options={entities}
            component={renderSelectField}
            onChange={(e) => {
              change('label', e.label);
              setSelectedValue(e?.value || null);
            }}
          />
          {renderDetails && renderDetails(selectedValue)}
        </div>
        <div className="form__form-group mb-0">
          <span className="form-header">{t('appLayout.labelField')}</span>
          <Field
            name="label"
            placeholder={t('appLayout.label')}
            component={renderField}
          />
          <span className="wl-pick__help">{t('appLayout.labelHelp')}</span>
        </div>
      </div>
      <div className="qm-footer">
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm mb-0"
          onClick={onClose}
        >
          {t('appLayout.cancel')}
        </button>
        <button type="submit" className="btn btn-primary btn-sm mb-0">
          {component?.value ? s('update') : s('create')}
        </button>
      </div>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'layout_component_form',
  validate: validateWebsiteComponentForm,
});

export default reduxF(WebsiteComponentForm);
